<template>
  <BaseAuthenticationLayout>
    <BaseHeader class="mb-6">
      <span>Réinitialiser le mot de passe</span>
    </BaseHeader>
    <form
      @submit.prevent
      @submit="submit"
    >
      <div :style="{'margin-bottom': '173px'}">
        <BaseInput
          v-model="email"
          label="Email"
          required
          type="email"
          class="mb-6"
        />
        <div
          :class="{ 'sticky-bottom neutral tone-100 py-6': $vuetify.breakpoint.mdAndDown }"
        >
          <BaseNotificationText
            class="mb-8 text-center"
            v-if="displayTimer"
          >
            {{ `Message envoyé, réessayer dans ${countdownText}` }}
          </BaseNotificationText>
          <BaseButton
            class="white--text my-2"
            color="brand-primary tone-400"
            :height="56"
            type="submit"
            block
          >
            Me connecter
          </BaseButton>
        </div>
      </div>
    </form>
  </BaseAuthenticationLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

import BaseHeader from '@/components/BaseHeader.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseNotificationText from '@/components/BaseNotificationText.vue';
import BaseAuthenticationLayout from '@/components/BaseAuthenticationLayout.vue';

export default {
  name: 'PasswordForgotten',
  components: {
    BaseHeader,
    BaseInput,
    BaseButton,
    BaseNotificationText,
    BaseAuthenticationLayout,
  },
  data() {
    return {
      displayTimer: false,
      countdown: 0,
    };
  },
  computed: {
    ...mapFields(['signUp.email', 'signUp.password']),
    ...mapState(['currentUser']),
    countdownText() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = (this.countdown % 60).toString().padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
  },
  methods: {
    ...mapActions(['resetPassword']),
    submit() {
      this.resetPassword().then(() => {
        this.reinitialize();
      });
    },
    reinitialize() {
      this.displayTimer = true;
      this.countdown = 300;
      this.countdownTimer();
    },
    countdownTimer() {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countdownTimer();
        }, 1000);
      }
    },
  },
};
</script>
